import React, { Fragment, useMemo } from 'react';
import { useIntl } from 'umi';
import { useSubtitle } from '../../hooks/useSubTitle';
import './index.scss';

export default function DetailSubtitle(props: any) {
  const { filter, detailFilter, defaultProps } = props;
  const { formatMessage } = useIntl();

  const { format, sortKeys, addSpecialTitle } = useSubtitle({ defaultProps });

  const subtitle = useMemo(() => {
    const keys = Object.keys(detailFilter || {});
    const renderKeys = sortKeys.filter((key) => keys.includes(key));

    const renderElements = renderKeys
      .map((key) => {
        const func = format[key];
        const value = detailFilter[key];
        const element = func(value, detailFilter, filter);
        if (!element) return null;
        return { key, element: addSpecialTitle(element) };
      })
      .filter((item) => item !== null);

    const len = renderElements.length;

    return (
      <>
        {formatMessage({ id: 'Selected:' })}{' '}
        {renderElements.map(({ key, element }, index) => {
          return (
            <Fragment key={key}>
              {element}
              {index !== len - 1 && ' & '}
            </Fragment>
          );
        })}
      </>
    );
  }, [detailFilter, filter, formatMessage]);

  return (
    <>
      {subtitle && (
        <div className="dbo-language-subtitle">
          <span>{subtitle}</span>
        </div>
      )}
    </>
  );
}
